export default __webpack_public_path__ + "static/media/UP.fdfa4430.svg";